/**
 * Site-level legal-document versions.
 *
 * Bumped manually when the content of /terms or /privacy materially changes
 * (e.g. a new operator paragraph, a new data-sharing clause). The submitted
 * value lands in `users.termsVersion` so legal can audit "which terms a
 * given user agreed to" without diffing the live page against snapshots.
 *
 * The site's weekly Contest Rules are stored separately in the
 * `weekly_rules` table and accessed via GET /event/weeks → rules.version.
 * Don't put weekly rules versions here.
 */
export const TERMS_VERSION = '2026-v2';
